import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import {ProspectActivity, MailCampaignMailClickProspectActivity} from 'api';
import {Link} from 'react-router-dom';
import {MailCampaign} from 'components/Ui/Icon';

interface MailCampaignMailClickActivity extends ProspectActivity {
  resource: MailCampaignMailClickProspectActivity;
}

interface Props {
  prospectActivity: MailCampaignMailClickActivity;
}

export default ({prospectActivity}: Props) => {
  const {resource: {mailCampaignSend} = {}} = prospectActivity;

  return (
    <>
      <MailCampaign />
      <Content>
        <ContentHeader>
          <h3>
            <Link
              target="_blank"
              to={`/pools/${mailCampaignSend.mailCampaign.pool.uuid}/mail_campaigns/${mailCampaignSend.mailCampaign.uuid}`}>
              {mailCampaignSend.mailCampaign.title}
            </Link>
          </h3>
          <time>
            {moment(prospectActivity.createdAt).format('YYYY/MM/DD HH:mm')}
          </time>
        </ContentHeader>
        <Wrapper>
          <a href={prospectActivity.resource.url} target="_blank">
            {prospectActivity.resource.url}
          </a>
        </Wrapper>
      </Content>
    </>
  );
};

const Content = styled.div`
  flex: 1;
  margin-left: 10px;
`;

const ContentHeader = styled.div`
  display: flex;
  align-items: center;
  min-height: 30px;

  h3 {
    flex: 1;
    margin: 0;
    color: var(--primary);
    font-weight: bold;
  }

  span,
  time {
    color: var(--text-color-2);
    margin-left: 15px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  color: var(--text-color-2);
  width: 100％;

  > a {
    max-width: 450px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
